import { validateTidalLicense } from "../../base/index.js";
import { upperCase } from "./utils/upperCase.js";
function properCase(source) {
  return source.toLowerCase().replace(/^\w|\s\w/g, upperCase);
}
validateTidalLicense();
export {
  properCase
};
//# sourceMappingURL=properCase.js.map
